export default __webpack_public_path__ + "static/media/aprioriblanco.3bbc2ef6.png";